import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid/";
import { useSelector } from "react-redux";
import {
  ButtonLink,
  getSiteSpecificStatus,
  statusColor,
} from "../../../../lib";
import { WatchActions } from "../../../../state";
import { format } from "date-fns";
export function StatusNotMatch(props) {
  const siteId = useSelector((state) => state.scopes.site_id);

  const [rows, setRows] = useState([]);
  useEffect(() => {
    (async function () {
      const statusNotMatch = await WatchActions.getStatusNotMatch(siteId);
      setRows(statusNotMatch);
    })();
  }, [siteId]);

  const renameValues = rows?.map((row) => ({
    id: row.item_id,
    model_no: row.model_no,
    date: format(new Date(row.act_date_added), "MMM-do yyyy"),
    PTstatus: getSiteSpecificStatus(row, 0),
    TWSstatus: getSiteSpecificStatus(row, 1),
    TPCstatus: getSiteSpecificStatus(row, 2),
    button: row.item_id,
  }));
  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.4,
      headerAlign: "center",
      align: "center",
    },
    { field: "date", headerName: "Date", flex: 0.5 },
    {
      field: "model_no",
      headerName: "Model",
      flex: 1.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "PTstatus",
      headerName: "PT Status",
      flex: 0.4,
      renderCell: (params) => {
        return statusColor(params.value);
      },
      filterable: false,
    },
    siteId === 0 || siteId === 1
      ? {
          field: "TWSstatus",
          headerName: " TWS Status",
          flex: 0.4,
          renderCell: (params) => {
            return statusColor(params.value);
          },
          filterable: false,
        }
      : {flex: 0.1},
    siteId === 0 || siteId === 2
      ? {
          field: "TPCstatus",
          headerName: "TPC Status",
          flex: 0.4,
          renderCell: (params) => {
            return statusColor(params.value);
          },
          filterable: false,
        }
      : { flex: 0.1},
    {
      field: "button",
      headerName: "Edit Watch",
      flex: 0.5,
      filterable: false,
      renderCell: (params) => {
        let link = `/edit-watch/${params.value}`;
        return (
          <ButtonLink
            variant="contained"
            color="primary"
            size="small"
            to={link}
          >
            View
          </ButtonLink>
        );
      },
      headerAlign: "left",
      align: "left",
    },
  ];

  return (
    <Box
      style={{
        width: "100%",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}></div>

      <div>
        {rows && (
          <DataGrid
            rows={renameValues}
            columns={columns}
            disableColumnMenu={true}
            isRowSelectable={false}
            pageSize={100}
            checkboxSelection={false}
            autoHeight={true}
            rowHeight={38}
            sortModel={[
              {
                field: "id",
                sort: "desc",
              },
            ]}
          />
        )}
      </div>
    </Box>
  );
}
